var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarmshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 99H21V54H27V93H90V54H96V99Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 84H33V66H54V84ZM39 78H48V72H39V78Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 57H48V63.235H54V57Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57H33V63.235H39V57Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86.765H48V93H54V86.765Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 86.765H33V93H39V86.765Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87 99H69V66H87V99ZM75 93H81V72H75V93Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57H68.8825V63H87V57Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66 54H60V93.01H66V54Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108 39H102C102 35.8325 97.855 28.7375 94.4775 24H22.8875C21.0325 27.985 18 35.275 18 39H12C12 32.48 17.67 20.9525 18.3175 19.6575L19.1475 18H97.5025L98.4025 19.2C100.005 21.3375 108.003 32.3375 108.003 39H108Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 51C46.71 51 42 46.29 42 40.5V39H48V40.5C48 42.9825 50.0175 45 52.5 45C54.9825 45 57 42.9825 57 40.5V39H63V40.5C63 46.29 58.29 51 52.5 51Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 51C31.71 51 27 46.29 27 40.5V39H33V40.5C33 42.9825 35.0175 45 37.5 45C39.9825 45 42 42.9825 42 40.5V39H48V40.5C48 46.29 43.29 51 37.5 51Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 51C16.71 51 12 46.29 12 40.5V39H18V40.5C18 42.9825 20.0175 45 22.5 45C24.9825 45 27 42.9825 27 40.5V39H33V40.5C33 46.29 28.29 51 22.5 51Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 51C61.71 51 57 46.29 57 40.5V39H63V40.5C63 42.9825 65.0175 45 67.5 45C69.9825 45 72 42.9825 72 40.5V39H78V40.5C78 46.29 73.29 51 67.5 51Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 51C76.71 51 72 46.29 72 40.5V39H78V40.5C78 42.9825 80.0175 45 82.5 45C84.9825 45 87 42.9825 87 40.5V39H93V40.5C93 46.29 88.29 51 82.5 51Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 51C91.71 51 87 46.29 87 40.5V39H93V40.5C93 42.9825 95.0175 45 97.5 45C99.9825 45 102 42.9825 102 40.5V39H108V40.5C108 46.29 103.29 51 97.5 51Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmshop);
export default __webpack_public_path__ + "static/media/Farmshop.5856b5f0.svg";
export { ForwardRef as ReactComponent };